import type { ListBuilderList } from '../../../types';
import { createQuoteShopDefaultColumns } from '../columns';
import {
	QUOTE_SHOP_DEFAULT_REQUIRED_FIELDS,
	QUOTE_SHOP_MOBILE_CARD_CONFIG,
} from '../shared';

/**
 * Quote Shop Default list configuration
 * All items available for purchase in the quote shop
 */
export const quoteShopDefaultList: ListBuilderList = {
	id: 'quote_shop_default',
	cacheTTL: 600000,
	name: 'Shop Items',
	type: 'default',
	active: true,
	sortOrder: 0,
	columns: createQuoteShopDefaultColumns(),
	description: 'Items available for purchase in the client shop',
	defaultSortId: 'in_stock_first',
	requiredFields: QUOTE_SHOP_DEFAULT_REQUIRED_FIELDS,
	mobileCardConfig: QUOTE_SHOP_MOBILE_CARD_CONFIG,
};
